import styled from "styled-components"
import { LazyLoadImage } from "react-lazy-load-image-component"

export const Box = styled.div`
    background-color: ${({ bg }) => bg ? bg : ''};
`
export const Span = styled.span`
    background-color: ${({ bg }) => bg ? bg : ''};
    font-size: ${props => props.size ? props.size : ""};
    font-family: ${props => props.family ? props.family : "var(--regular)"};
    font-weight: ${props => props.weight ? props.weight : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
    }
`

export const IconBoxColor = styled.div`
    svg {
        [stroke] {
            stroke: ${({ iconColor }) => iconColor ? iconColor : ''};
        }
    }
`

export const LazyImage = (props) => {
    return (
        <LazyLoadImage className="custom-img"
            {...props}
            effect="blur"
        />
    )
}


export const SpanStyled = styled.span`
    color:${props => props.color ? props.color : ""};
    line-height: ${props => props.lh ? props.lh : ''};
    font-size:${props => props.size ? props.size : ''};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
    
`

export const HeadingStyled = styled.div`
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : ''};
    font-size:${props => props.size ? props.size : '20px'};
    display: ${props => props.display ? props.display : ''};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
`
export const HeadingStyled2 = styled.div`
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "60px"};
    font-size: ${props => props.size ? props.size : '40px'};
    display: ${props => props.display ? props.display : 'flex'};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.family ? props.family : "var(--regularBold)"};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arBoldSans)"};
    }
    
`
export const HeadingStyledD = styled.div`
    color:${props => props.color ? props.color : "var(--text)"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "40px"};
    font-size: ${props => props.size ? props.size : "24px"};
    display: ${props => props.display ? props.display : 'flex'};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.family ? props.family : "var(--regularBold)"};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arBoldSans)"};
    }
`
export const SubHeadingStyled = styled.div`
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : ''};
    font-size:${props => props.size ? props.size : '24px'};
    display: ${props => props.display ? props.display : ''};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
`
export const MainHeading = styled.div`
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : 'normal'};
    font-size:${props => props.size ? props.size : '36px'};
    display: ${props => props.display ? props.display : 'flex'};
    width: ${props => props.display ? props.display : '100%'};
    font-weight:${props => props.weight ? props.weight : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
`
export const TextStyled = styled.p`
    display: ${props => props.display ? props.display : 'flex'};
    width: ${props => props.display ? props.display : '100%'};
    line-height: ${props => props.lh ? props.lh : '24px'};
    font-size:${props => props.size ? props.size : '15px'};
    font-weight:${props => props.weight ? props.weight : ''};
    color:${props => props.color ? props.color : "var(--text)"};
    text-transform: ${props => props.transform ? props.transform : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
`

export const LabelStyled = styled.label`
    line-height:${props => props.lh ? props.lh : ''};
    font-size:${props => props.size ? props.size : '14px'};
    font-weight:${props => props.weight ? props.weight : '500'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    color:${props => props.color ? props.color : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--regular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--arRegular)"};
`

export const ButtonStyled = styled.button`
    transition: 0.3s ease-in-out opacity;
    font-size:${props => props.size ? props.size : '16px'};
    font-weight:${props => props.weight ? props.weight : '500'};
    background:${props => props.bg ? props.bg : "none"};
    color: ${props => props.color ? props.color : "var(--ThemeColor)"};
    padding: ${props => props.padding ? props.padding : "11px 20px"};
    border: ${props => props.border ? props.border : "none"};
    width: ${props => props.width ? props.width : "100%"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "normal"};
    border-radius: ${props => props.radius ? props.radius : "8px"};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    font-family: ${props => props.direction === 'rtl' && props.family ? props.family : "var(--arRegular)"},
                ${props => props.direction === 'ltr' && props.family ? props.family : "var(--regular)"};
    
`


export const DurationSelect = styled.select`
  padding: 8px 12px;
  font-size: 16px;
  border: 2px solid var(--themeColor2);
  border-radius: 8px;
  background-color: white;
  color: var(--text);
  outline: none;
  transition: all 0.3s ease;
  text-align: center;
  min-width: 200px;

  &:hover {
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.2);
  }

  &:focus {
    border-color: var(--themeColor);
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const DurationToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
`;

export const DurationToggle = styled.div`
  display: flex;
  border-radius: 50px;
  background-color: var(--themeColor);
  padding: 5px;
  width: fit-content;
`;

export const DurationOption = styled.button`
  background-color: ${({ active }) => (active ? "white" : "var(--themeColor)")};
  color: ${({ active }) => (active ? "var(--themeColor)" : "white")};
  font-weight: 600;
  padding: 10px 25px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s ease;
  font-size: 16px;

  &:hover {
    opacity: 0.85;
  }
`;
